import { combineReducers } from "redux";
import app from "./appReducers";

export default combineReducers({ app });
